module.exports = __webpack_public_path__ + "static/scale-model-of-camp-randall-memorial-in-madison-wisconsin-afb090116fbf142575a04cc52b4087b0.png";